<template>
  <div>
    {{orderReviewMessage}}
    <div v-if="value">
      <a href="#" @click.prevent="dontSkipReview">[Re-enable review]</a>
    </div>
    <div v-else-if="allowSkipApproval">
      <a  v-b-tooltip.hover.bottom
          title="Skip review process for this order. Shown because you are an admin."
          href="#" @click.prevent="skipReview">[Skip review]</a>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  props: ['value'],
  computed: {
    ...mapGetters(['isAdmin', 'approvalSettings']),
    orderReviewMessage() {
      let {approvalMode} = this.approvalSettings;
      if (this.value) {
        return 'Review skipped for this order';
      } else if (approvalMode === "payment") {
        return 'Billing information will be entered by the admin';
      } else if (approvalMode === "review") {
        return 'Order will be reviewed by the admin';
      } else {
        return '';
      }
    },
    allowSkipApproval() {
      return this.approvalSettings.approvalMode && this.isAdmin;
    },
  },
  methods: {
    skipReview() {
      this.$emit('input', true);
    },
    dontSkipReview() {
      this.$emit('input', false);
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/checkout/OrderReviewMessage.vue